@use '@lib/assets/styles/main.scss' as *;

.inputPasswordRoot {
  display: grid;
  grid-template-columns: auto min-content;
  grid-gap: 16px;
  align-items: center;
}
